import React from 'react';
import css from './Sections.module.css';
import classNames from 'classnames';
import partnerImg1 from '../../../../assets/companylogo1.png';
import partnerImg2 from '../../../../assets/companylogo2.png';
import partnerImg3 from '../../../../assets/companylogo3.png';
import partnerImg4 from '../../../../assets/companylogo4.png';
import partnerImg5 from '../../../../assets/companylogo5.png';
import partnerImg6 from '../../../../assets/companylogo6.png';
import TeknismartLogo from '../../../../assets/TeknismartLogo.png';
import IdentopiaLogo from '../../../../assets/IdentopiaLogo.png';
import Slider from 'react-slick';
import '../../../../styles/slick/slick.css';
import '../../../../styles/slick/slick-theme.css';

function SectionPartners(props) {
  const { intl, viewport } = props;

  const settings = {
    dots: false,
    infinite: true,
    autoplaySpeed: 5000,
    arrows: false,
    autoplay: true,
    speed: 5000,
    cssEase: 'linear',
    slidesToShow: 2, // Display 4 items on desktop
    slidesToScroll: 1, // Scroll 1 item at a time
    variableWidth: false,
    focusOnSelect: false,
    centerMode: true,
    responsive: [
      {
        breakpoint: 1024, // Adjust settings for smaller viewports
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768, // Adjust settings for smaller viewports
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 580, // Adjust settings for smaller viewports
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 480, // Adjust settings for smaller viewports
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div className={classNames(css.sectionAbout, css.sectionPartners)}>
      <div className={css.fixedWidthContainer}>
        {/* <div className={css.sectionHeader}>
          <h1>Our Partners</h1>
          <p>Official partner of these companies</p>
        </div> */}
        <div className={css.sectionContent}>
          <Slider {...settings}>
            <div className={css.slideItem}>
              <img src={TeknismartLogo} alt="" />
            </div>
            <div className={css.slideItem}>
              <img src={IdentopiaLogo} alt="" />
            </div>
            {/* <div className={css.slideItem}>
              <img src={partnerImg3} alt="" />
            </div>
            <div className={css.slideItem}>
              <img src={partnerImg4} alt="" />
            </div>
            <div className={css.slideItem}>
              <img src={partnerImg5} alt="" />
            </div>
            <div className={css.slideItem}>
              <img src={partnerImg6} alt="" />
            </div> */}
          </Slider>
        </div>
      </div>
    </div>
  );
}

export default SectionPartners;
